import React from 'react'
import Configurator from '../../../../configurator'
import { SortableTreeWithoutDndContext as SortableTree } from '@nosferatu500/react-sortable-tree'
import {
    i18nWrapper,
    withConnectWrapper,
} from '../../../../validator'
import {
    loadOrganizingTree,
    setGroupParent,
} from '../../../ducks/groups-admin'
import {
    mapGroupsToSortableTree,
    mapSortableTreeToSimpleGroups,
} from './mapper'
import OverlayLoader from '../../../../components/shared/overlay-loader'
import Button from '../../../../front/components/shared/sn-button'
import classnames from 'classnames'
import Link from '../../../../front/components/shared/sn-link'
import SnIcon from '../../../../front/components/shared/sn-icon'
import { DndProvider } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'
import { TouchBackend } from 'react-dnd-touch-backend'

const isTouchDevice = !!('ontouchstart' in window || navigator.maxTouchPoints)
const dndBackend = isTouchDevice ? TouchBackend : HTML5Backend

// https://github.com/frontend-collective/react-sortable-tree
class TreeChanger extends Configurator {
    state = {
        busy: false,
        treeData: [],
        treeChanged: false,
        numGroups: 1,
        processing: 0,
        toProcessing: 0,
    }

    componentDidMount() {
        this.initGroups()
    }

    /**
     * On groups init
     */
    initGroups = () => {
        const { groups } = this.props

        if (!groups || groups.length === 0) {
            this.setState({ busy: true })
            loadOrganizingTree()
                .then(groupsPromise => {
                    this.setState({
                        treeData: mapGroupsToSortableTree(groupsPromise),
                        numGroups: groupsPromise.length,
                        busy: false,
                    })
                })

            return
        }

        this.setState({
            treeData: mapGroupsToSortableTree(groups),
            numGroups: groups.length,
        })
    }

    /**
     * Save tree
     */
    saveTree = () => {
        const { treeData } = this.state
        const {
            t,
            history,
        } = this.props

        const groupsData = mapSortableTreeToSimpleGroups(treeData)
        this.setState({
            processing: 1,
            toProcessing: groupsData.length,
            busy: true,
        })

        Promise
            .allSettled(groupsData.map(group => {
                return setGroupParent(group.slug, group.parent, group.order)
                    .then(() => this.setState({ processing: this.state.processing + 1 }))
            }))
            .then(() => this.setState({ busy: false }))
            .then(() => window.swalert(t('done'), 'success', () => history.push('/admin/clubs')))
    }

    /**
     * Render
     *
     * @returns {*}
     */
    render() {
        const {
            busy,
            treeData,
            treeChanged,
            numGroups,
            processing,
            toProcessing,
        } = this.state

        const { t } = this.props

        return (
            <div>
                <Link
                    to="/admin/clubs"
                    className="d-flex flex-row align-items-center col-12 col-sm-2 mb-3"
                >
                    <SnIcon className="sn-arrow mr-2" />{t('backToList')}
                </Link>
                <DndProvider backend={dndBackend}>
                    <div style={{height: (numGroups * 62) + 20}}>
                        <SortableTree
                            treeData={treeData}
                            onChange={treeData => this.setState({
                                treeData,
                                treeChanged: true,
                            })}
                            getNodeKey={({ node }) => node.id}
                            onMoveNode={nodeMove => {
                                const {
                                    node,
                                    nextParentNode,
                                } = nodeMove

                                node.parent = nextParentNode?.id || null
                            }}
                        />
                    </div>
                </DndProvider>
                <div>
                    <Button
                        onClick={this.saveTree}
                        className={classnames({
                            'btn btn-color-brand d-flex flex-row align-items-center col-12 col-sm-2 justify-content-center': true,
                            'btn-disabled': !treeChanged,
                            'btn-loading': busy,
                        })}
                    >
                        {t('save')}
                    </Button>

                    {busy && (
                        <div className="progress">
                            <div
                                className="progress-bar"
                                style={{ width: `${((processing - 1) / toProcessing) * 100}%` }}
                                role="progressbar"
                                aria-valuenow={((processing - 1) / toProcessing) * 100}
                                aria-valuemin="0"
                                aria-valuemax="100"
                            />
                        </div>
                    )}
                </div>
                {busy && <OverlayLoader />}
            </div>
        )
    }

}

export default withConnectWrapper(state => ({
    groups: state.groupsAdmin.groups,
}))(i18nWrapper(TreeChanger))
